import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgSeedsWhite = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="44"
        width="48"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 48 44"
    >
        <path
            d="M48 9.77778V15.8889C48 20.1029 46.3564 24.1443 43.4309 27.124C40.5053 30.1038 36.5374 31.7778 32.4 31.7778H26.4V44H21.6V26.8889L21.6456 24.4444C21.9479 20.4538 23.7178 16.7263 26.6015 14.0072C29.4852 11.2881 33.2702 9.77762 37.2 9.77778H48ZM9.6 9.66459e-07C13.1268 -0.00120599 16.5646 1.1281 19.4261 3.22787C22.2876 5.32764 24.4277 8.29139 25.5432 11.6991C23.707 13.2845 22.2026 15.2298 21.1195 17.4194C20.0364 19.6089 19.3967 21.998 19.2384 24.4444H16.8C12.3444 24.4444 8.07122 22.6417 4.92061 19.4327C1.76999 16.2238 0 11.8715 0 7.33333V9.66459e-07H9.6Z"
            fill="white"
        />
    </svg>
);

export const SeedsWhiteIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgSeedsWhite}
        fontSize={fontSize}
    />
);
